import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isOwnBackend, KEEP_SESSION_ON_401 } from './backend';
import { SessionService } from './session.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  // Injector statt SessionService: SessionService -> LoginService ->
  // HttpClient -> Interceptor wäre ein DI-Zyklus.
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 401 &&
          isOwnBackend(req.url) &&
          !req.context.get(KEEP_SESSION_ON_401)
        ) {
          // Einmal-Guard und Schleifen-Deckel liegen im SessionService.
          this.injector.get(SessionService).handleUnauthorized();
        }
        return throwError(error);
      })
    );
  }
}
